import {
  CLOSE_CONSUMPTION_BYPASS_MODAL,
  SHOW_CONSUMPTION_BYPASS_MODAL,
  ConsumptionBypassModalAction,
} from '@actions/ui/consumptionBypassModal'

export interface ConsumptionBypassModalState {
  show: boolean
  title?: string
}

const initialState: ConsumptionBypassModalState = {
  show: false,
}

export const consumptionBypassModal = (
  state: ConsumptionBypassModalState = initialState,
  action: ConsumptionBypassModalAction,
): ConsumptionBypassModalState => {
  const { type } = action

  switch (type) {
    case SHOW_CONSUMPTION_BYPASS_MODAL:
      return { show: true, title: action.title }
    case CLOSE_CONSUMPTION_BYPASS_MODAL:
      return { show: false }
    default:
      return state
  }
}
